<template>
  <header
    class="public-header"
    style="z-index: 9999999998;"
  >
    <!-- ===================================================== -->
    <!-- TOP UTILITY BAR -->
    <!-- ===================================================== -->

    <div class="public-utility-bar" 
      :style="{ ...sysTypo.sectionTypography.body, background: themeStore.sectionTheme.systemBarBg, color: themeStore.sectionTheme.systemBarColor }"
       style="z-index: 999999999999999999; height: 50px;"
      >
      <v-container
        fluid
        class="responsive-x-padding utility-fluid-container"
        style="z-index: 999999999999999999; height: 50px;"
      >

          <div class="system-bar-content" style="z-index: 999999999999999999; padding-top: 16px; padding-bottom: 10px;">

            <!-- LEFT SECTION -->
            <div class="system-bar-left">

              <!-- LinkedIn -->
              <v-tooltip
                :text="t('visitLinkedInPage')"
                location="bottom"
              >
                <template #activator="{ props }">
                  <a
                    :href="getDisplaySettings.linkedInUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="social-link"
                  >
                    <v-icon
                      v-bind="props"
                      size="32"
                      class="formaticon langcolor"
                      :style="{ color: themeStore.sectionTheme.systemBarBtnColor }"
                    >
                      mdi-linkedin
                    </v-icon>
                  </a>
                </template>
              </v-tooltip>

              <!-- WhatsApp -->
              <v-tooltip
                :text="t('contactViaWhatsApp')"
                location="bottom"
              >
                <template #activator="{ props }">
                  <a
                    :href="getDisplaySettings.whatsAppUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="social-link"
                  >
                    <v-icon
                      v-bind="props"
                      size="32"
                      class="formaticon langcolor"
                      :style="{
                        color: themeStore.sectionTheme.systemBarBtnColor
                      }"
                    >
                      mdi-whatsapp
                    </v-icon>
                  </a>
                </template>
              </v-tooltip>

              <!-- Facebook -->
              <v-tooltip
                :text="t('visitFacebookPage')"
                location="bottom"
              >
                <template #activator="{ props }">
                  <a
                    :href="getDisplaySettings.facebookUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="social-link"
                  >
                    <v-icon
                      v-bind="props"
                      size="32"
                      class="formaticon langcolor"
                      :style="{

                        color: themeStore.sectionTheme.systemBarBtnColor,
                      }"
                    >
                      mdi-facebook
                    </v-icon>
                  </a>
                </template>
              </v-tooltip>

              <!-- Twitter -->
              <v-tooltip
                :text="t('visitTwitterPage')"
                location="bottom"
              >
                <template #activator="{ props }">
                  <a
                    :href="getDisplaySettings.twitterUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="social-link"
                  >
                    <v-icon
                      v-bind="props"
                      size="28"
                      class="formaticon langcolor"
                      :style="{
                        color: themeStore.sectionTheme.systemBarBtnColor,
                      }"
                    >
                      mdi-twitter
                    </v-icon>
                  </a>
                </template>
              </v-tooltip>

              <!-- Instagram -->
              <v-tooltip
                v-if="mdAndUp"
                :text="t('visitInstagramPage')"
                location="bottom"
              >
                <template #activator="{ props }">
                  <a
                    :href="getDisplaySettings.instalgramUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="social-link"
                  >
                    <v-icon
                      v-bind="props"
                      size="32"
                      class="formaticon langcolor"
                      :style="{
                        color: themeStore.sectionTheme.systemBarBtnColor,
                      }"
                    >
                      mdi-instagram
                    </v-icon>
                  </a>
                </template>
              </v-tooltip>

            </div>

            <!-- RIGHT SECTION -->
            <div class="system-bar-right" style="z-index: 999999999999999999; ">

              <!-- Desktop actions -->
              <div
              v-if="hostname === 'lizmindset.health'"
                class="main-app-bar__actions"
                style="z-index: 999999999999999999;"
              >
                <span class="d-none d-md-flex">
                  <VuetifySearch />
                </span>

                <v-tooltip
                  v-if="
                    (tenantx === 'localhost' ||
                      tenantx === 'nexgbits-hosting') &&
                    isUserLogin === 'true'
                  "
                  text="Telephone number"
                  location="bottom"
                >
                  <template #activator="{ props }">
                      <span 
                      v-bind="props"
                       :style="{
                        color: themeStore.sectionTheme.systemBarBtnColor,
                      }">TEL (940)-235-6491</span>
                  </template>
                </v-tooltip>

                <v-tooltip
                  text="Telephone number"
                  location="bottom"
                  style=" z-index: 9999999999999999999;"
                  v-if="hostname === 'lizmindset.health'"
                >
                  <template #activator="{ props }" v-if="hostname === 'lizmindset.health'">
                    <span
                    
                     v-bind="props"
                       :style="{
                        color: themeStore.sectionTheme.systemBarBtnColor,
                      }">TEL (940)-235-6491</span>
                  </template>
                </v-tooltip>
              </div>
              <!-- THEME -->

            <v-menu
              v-model="toprightmenu"
              :close-on-content-click="false"
              location="bottom end"
               style=" z-index: 9999999999999999999;"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text"
                  class="system-action-button"
                  :style="{
                    color: themeStore.sectionTheme.systemBarBtnColor
                  }"
                   style=" z-index: 9999999999999999999;"
                >
                  <div class="system-action-content">
                    <v-icon size="26">
                      mdi-theme-light-dark
                    </v-icon>
                  </div>
                </v-btn>
              </template>

              <v-card
                min-width="300"
                :style="{
                  color: themeStore.sectionTheme.systemBarBtnColor
                }"
                 style=" z-index: 9999999999999999999;"
              >
                <v-row class="ma-2">
                  <v-col
                    cols="4"
                    class="text-center"
                  >
                    <v-switch
                      v-model="lightSwitch"
                      color="purple"
                      hide-details
                      @change="selectTheme('light')"
                    />

                    <div>
                      {{
                        t(
                          "nbthemecardtitletext7"
                        )
                      }}
                    </div>
                  </v-col>

                  <v-col
                    cols="4"
                    class="text-center"
                     style=" z-index: 9999999999999999999;"
                  >
                    <v-switch
                      v-model="darkSwitch"
                      color="purple"
                      hide-details
                      @change="selectTheme('dark')"
                    />

                    <div>
                      {{
                        t(
                          "nbthemecardtitletext8"
                        )
                      }}
                    </div>
                  </v-col>

                  <v-col
                    cols="4"
                    class="text-center"
                     style=" z-index: 9999999999999999999;"
                  >
                    <v-switch
                      v-model="hybridSwitch"
                      color="purple"
                      hide-details
                      @change="selectTheme('hybrid')"
                    />

                    <div>
                      {{
                        t(
                          "nbthemecardtitletext9"
                        )
                      }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>

            <!-- LANGUAGE -->
            <v-tooltip
              :text="t('changeLanguage') || 'Change language'"
              location="bottom"
               style=" z-index: 9999999999999999999;"
            >
              <template #activator="{ props }" style="z-index: 999999999999999999;">
                <div
                  v-bind="props"
                  class="language-switcher-wrapper"
                  :style="{
                    ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.systemBarBtnColor
                  }"
                  style=" z-index: 9999999999999999999;"
                >
                  <LanguageSwitcher
                    @change="onLanguageChange"
                  />
                </div>
              </template>
            </v-tooltip>


            <!-- LOGIN / LOGOUT -->
            <v-tooltip
              :text="
                isUserLogin === 'true'
                  ? t('logout')
                  : t('nblogin')
              "
              location="bottom"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  class="systembar-icon-btn"
                  @click="goToLogin"
                >
                  <v-icon
                    size="26"
                    class="formaticon langcolor"
                    :style="{
                      color: themeStore.sectionTheme.systemBarBtnColor
                    }"
                  >
                    {{
                      isUserLogin === 'true'
                        ? 'mdi-logout'
                        : 'mdi-login'
                    }}
                  </v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            </div>
          </div>
      </v-container>
    </div>

    <!-- ===================================================== -->
    <!-- MAIN APP BAR -->
    <!-- ===================================================== -->

    <div class="main-app-bar" 
      :style="{ ...sysTypo.sectionTypography.body, background: themeStore.sectionTheme.appBarBg, color: themeStore.sectionTheme.appBarColor }"
      style="z-index: 999998; height: 90px;"
      >
      <v-container
        class="responsive-x-padding utility-fluid-container"
      >
        <div
          class="main-app-bar__content"
          style="margin-top: 50px;"
        >
          <!-- ================================================= -->
          <!-- TABLET / MOBILE MENU BUTTON -->
          <!-- ================================================= -->

          <v-btn
            icon
            size="small"
            variant="text"
            class="main-app-bar__nav-icon mobile-nav-toggle"
            :aria-label="
              currentLanguage === 'fr'
                ? 'Ouvrir le menu de navigation'
                : 'Open navigation menu'
            "
            @click.stop="emit('toggle-drawer')"
            :style="{
              ...sysTypo.sectionTypography.body,
              color: themeStore.sectionTheme.appBarBtnColor
            }"
          >
            <v-icon>
              mdi-menu
            </v-icon>
          </v-btn>

          <!-- ================================================= -->
          <!-- LOGO -->
          <!-- ================================================= -->

          <router-link
            :to="homeRoute"
            class="header-logo-link"
            aria-label="Nexgbits home"
          >
            <v-img
              v-if="getCurrentTheme === 'light'"
              :src="getLogoLight"
              class="header-logo-image"
              style="width: 600px; height: 220px;"
              contain
            />

            <v-img
              v-else
              :src="getLogoDark"
              class="header-logo-image"
              contain
              style="width: 600px; height: 220px;"
            />
          </router-link>

          <!-- ================================================= -->
          <!-- DESKTOP MENUS -->
          <!-- ================================================= -->

          <div
            class="main-app-bar__menus desktop-nav"
          >
            <MenuDropDown
              v-if="
                getDisplaySettings.menuType ===
                'DropDown'
              "
            />

            <MegaMenufull
              v-if="
                getDisplaySettings.menuType ===
                'MegaMenu'
              "
            />

            <MegaMenuHybrid
              v-if="
                getDisplaySettings.menuType ===
                'Hybrid'
              "
            />
          </div>

          <!-- ================================================= -->
          <!-- SEARCH DIALOG -->
          <!-- ================================================= -->

          <SearchDialogheader
            v-model="searchDialogOpen"
          />

          <!-- ================================================= -->
          <!-- RIGHT ACTIONS -->
          <!-- ================================================= -->

          <div class="main-app-bar__right">
            <!-- SEARCH -->

            <v-tooltip
              location="bottom"
              :text="
                currentLanguage === 'fr'
                  ? 'Rechercher'
                  : 'Search'
              "
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text"
                  class="system-action-button"
                  :aria-label="
                    currentLanguage === 'fr'
                      ? 'Rechercher'
                      : 'Search'
                  "
                  @click="searchDialogOpen = true"
                  :style="{
                    ...sysTypo.sectionTypography.body,
                    color: themeStore.sectionTheme.appBarBtnColor
                  }"
                >
                  <div class="system-action-content">
                    <v-icon size="28">
                      mdi-magnify
                    </v-icon>

                    <span class="system-action-label">
                      {{
                        currentLanguage === "fr"
                          ? "Recherche"
                          : "Search"
                      }}
                    </span>
                  </div>
                </v-btn>
              </template>
            </v-tooltip>

            <!-- GET STARTED -->

            <v-tooltip
              :text="
                currentLanguage === 'fr'
                  ? 'Créer un compte'
                  : 'Sign up or create an account'
              "
              location="bottom"
              v-if="hostname === 'nexgbits-hosting.com'"
            >
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text"
                  class="system-action-button"
                  @click="goToCreateAccount"
                  :style="{
                    ...sysTypo.sectionTypography.button,
                    color: themeStore.sectionTheme.appBarBtnColor
                  }"
                >
                  <div class="system-action-content">
                    <v-icon size="28">
                      mdi-shield-account-variant-outline
                    </v-icon>

                    <span class="system-action-label">
                      {{
                        currentLanguage === "fr"
                          ? "Commencer"
                          : "Get Started"
                      }}
                    </span>
                  </div>
                </v-btn>
              </template>
            </v-tooltip>

            
          </div>
        </div>
      </v-container>
    </div>
  </header>
</template>

<script setup>
import { computed, inject, onMounted, ref, watch } from "vue"
import { useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import LanguageSwitcher from "@/components/LanguageSwitcher.vue"

import MenuDropDown from "@/components/MenuDropDown.vue"
import MegaMenufull from "@/components/MegaMenufull.vue"
import MegaMenuHybrid from "@/components/MegaMenuHybrid.vue"
import SearchDialogheader from "@/components/SearchDialogheader.vue"
import publicApi from "@/auth/publicApi"
import { useLangStore } from "@/store/lang"
import { useThemeStore, useAuthStore } from "@/store/auth"

import { useSysTypo } from "@/store/useSysTypo";
const sysTypo = useSysTypo();
// ============================================================
// ROUTER
// ============================================================

const router = useRouter()

// ============================================================
// STORES
// ============================================================

const langStore = useLangStore()
const themeStore = useThemeStore()
const auth = useAuthStore()

// ============================================================
// I18N
// ============================================================
const { t, locale } = useI18n()

// ============================================================
// EVENTS
// ============================================================
 const hostname =
    window.location.hostname
      ?.trim()
      .toLowerCase();

const emit = defineEmits([
    "toggle-drawer"
  ])

// ============================================================
// LANGUAGE
// ============================================================

const currentLanguage =
  computed(() =>
    langStore.currentLanguage ||
    "en"
  )

watch(
  currentLanguage,
  newLanguage => {
    locale.value =
      newLanguage ||
      "en"
  },
  {
    immediate:
      true
  }
)

// ============================================================
// THEME
// ============================================================

const getCurrentTheme =
  computed(() =>
    themeStore.currentTheme ||
    localStorage.getItem(
      "currentTheme"
    ) ||
    "light"
  )

const lightSwitch =
  ref(false)

const darkSwitch =
  ref(false)

const hybridSwitch =
  ref(false)

const toprightmenu =
  ref(false)

function selectTheme(
  selectedTheme
) {
  lightSwitch.value =
    selectedTheme ===
    "light"

  darkSwitch.value =
    selectedTheme ===
    "dark"

  hybridSwitch.value =
    selectedTheme ===
    "hybrid"

  themeStore.setTheme(
    selectedTheme
  )

  localStorage.setItem(
    "currentTheme",
    selectedTheme
  )

  toprightmenu.value =
    false
}

// ============================================================
// LOGOS
// ============================================================

const getLogoLight =
  ref("")

const getLogoDark =
  ref("")

// ============================================================
// HOME
// ============================================================

const homeRoute =
  computed(() => ({
    name:
      "PublicHome",

    params: {
      lang:
        currentLanguage.value
    }
  }))

// ============================================================
// DISPLAY SETTINGS
// ============================================================

const getDisplaySettings =
  ref({})

// ============================================================
// SEARCH
// ============================================================

const searchDialogOpen =
  ref(false)

// ============================================================
// ACCOUNT
// ============================================================

const accountMenu =
  ref(false)

const isUserLogin =
  ref("")

const displayName =
  computed(() =>
    auth.loginName ||
    auth.user?.name ||
    auth.user?.displayName ||
    (
      currentLanguage.value ===
      "fr"
        ? "Compte"
        : "Account"
    )
  )

// ============================================================
// CART
// ============================================================

const cartStore =
  inject(
    "cartStore",
    null
  )

const itemCount =
  computed(() => {
    const value =
      cartStore?.itemCount

    if (
      value &&
      typeof value ===
        "object" &&
      "value" in value
    ) {
      return Number(
        value.value ||
        0
      )
    }

    return Number(
      value ||
      0
    )
  })

const formattedTotal =
  computed(() => {
    const value =
      cartStore?.formattedTotal

    if (
      value &&
      typeof value ===
        "object" &&
      "value" in value
    ) {
      return (
        value.value ||
        ""
      )
    }

    return (
      value ||
      ""
    )
  })

function openCart() {
  if (
    typeof cartStore
      ?.openCart ===
      "function"
  ) {
    cartStore.openCart()
    return
  }

  if (
    typeof cartStore
      ?.openDrawer ===
      "function"
  ) {
    cartStore.openDrawer()
    return
  }

  if (
    cartStore &&
    "drawerOpen" in
      cartStore
  ) {
    cartStore.drawerOpen =
      true

    return
  }

  console.log(
    "[PublicHeader] Cart clicked."
  )
}

// ============================================================
// CURRENCY
// ============================================================

const currencyMenu =
  ref(false)

const currencies = [
  {
    code:
      "CAD",

    label:
      "C$ CAD"
  },

  {
    code:
      "USD",

    label:
      "$ USD"
  },

  {
    code:
      "EUR",

    label:
      "€ EUR"
  }
]

const selectedCurrency =
  ref(
    currencies[0]
  )

function selectCurrency(
  currency
) {
  selectedCurrency.value =
    currency

  localStorage.setItem(
    "currency",
    currency.code
  )

  currencyMenu.value =
    false
}

// ============================================================
// CONTACT
// ============================================================

function goToContact() {
  console.log(
    "[PublicHeader] Contact clicked."
  )
}

// ============================================================
// PROFILE
// ============================================================

async function goToProfile() {
  accountMenu.value =
    false

  const routeName =
    currentLanguage.value ===
    "fr"
      ? "EditProfileFR"
      : "EditProfileEN"

  try {
    await router.push({
      name:
        routeName
    })
  }
  catch (error) {
    console.warn(
      `Unable to navigate to "${routeName}".`,
      error
    )
  }
}

// ============================================================
// CREATE ACCOUNT
// ============================================================

async function goToCreateAccount() {
  try {
    await router.push({
      name:
        "CreateAccount",

      params: {
        lang:
          currentLanguage.value
      }
    })
  }
  catch (error) {
    console.warn(
      "Unable to navigate to CreateAccount.",
      error
    )
  }
}

// ============================================================
// LOGIN
// ============================================================

async function goToLogin() {
  if (
    isUserLogin.value ===
    "true"
  ) {
    await auth.logout()

    isUserLogin.value =
      "false"
  }

  await router.push({
    name:
      "Login",

    params: {
      lang:
        currentLanguage.value
    }
  })
}

// ============================================================
// LOGOUT
// ============================================================

async function handleLogout() {
  accountMenu.value =
    false

  await auth.logout()

  isUserLogin.value =
    "false"

  await router.push({
    name:
      "Login",

    params: {
      lang:
        currentLanguage.value
    }
  })
}

// ============================================================
// INITIALIZE
// ============================================================

onMounted(
  async () => {
    try {
      const response =
        await publicApi.get(
          "/PageDisplaySetting/search",
          {
            params: {
              filterText:
                "homePage"
            }
          }
        )

      getDisplaySettings.value =
        response.data?.[0] ||
        {}
    }
    catch (error) {
      console.error(
        "Unable to load display settings:",
        error
      )
    }

    getLogoLight.value =
      localStorage.getItem(
        "LogoLight"
      ) ||
      ""

    getLogoDark.value =
      localStorage.getItem(
        "LogoDark"
      ) ||
      ""

    isUserLogin.value =
      localStorage.getItem(
        "isLogin"
      ) ||
      ""

    const selectedTheme =
      themeStore.currentTheme ||
      localStorage.getItem(
        "currentTheme"
      ) ||
      "light"

    lightSwitch.value =
      selectedTheme ===
      "light"

    darkSwitch.value =
      selectedTheme ===
      "dark"

    hybridSwitch.value =
      selectedTheme ===
      "hybrid"

    const savedCurrency =
      localStorage.getItem(
        "currency"
      )

    if (
      savedCurrency
    ) {
      const matchingCurrency =
        currencies.find(
          currency =>
            currency.code ===
            savedCurrency
        )

      if (
        matchingCurrency
      ) {
        selectedCurrency.value =
          matchingCurrency
      }
    }
  }
)
</script>

<style scoped>
/* ============================================================
   STICKY HEADER ROOT
============================================================ */

.public-header {
  position: sticky;
  top: 0;

  display: block;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  box-sizing: border-box;

  /*
   * Creates a dedicated stacking context for the complete
   * header so page sections scroll underneath it.
   */
  isolation: isolate;

   mix-blend-mode: normal !important;

  filter: none !important;

  border-bottom:
    1px solid
    rgba(0, 0, 0, 0.08);
}


/* ============================================================
   SYSTEM / UTILITY BAR
============================================================ */

.public-utility-bar {
  position: relative;
  display: block;

  width: 100%;
  max-width: 100%;

  height: 28px;
  min-height: 28px;

  box-sizing: border-box;
  mix-blend-mode: normal !important;

  filter: none !important;
}


/* ============================================================
   UTILITY CONTAINER
============================================================ */

.utility-fluid-container {
  display: flex;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  height: 28px;

  margin: 0 !important;

  align-items: center;
  justify-content: space-between;

  box-sizing: border-box;

  font-size: 11px;
}


/* ============================================================
   MAIN APP BAR
============================================================ */

.main-app-bar {
  position: relative;

  display: block;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  height: 56px;
  min-height: 56px;

  box-sizing: border-box;

  mix-blend-mode: normal !important;

  filter: none !important;

  overflow: visible;
}


/* ============================================================
   MAIN CONTAINER
============================================================ */

.header-fluid-container {
  display: flex;

  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;

  height: 56px;

  margin: 0 !important;

  box-sizing: border-box;
}


/* ============================================================
   MAIN CONTENT
============================================================ */

.main-app-bar__content {
  display: flex;

  width: 100%;
  max-width: 100%;
  min-width: 0;

  height: 56px;

  align-items: center;

  gap: 8px;

  box-sizing: border-box;
}


/* ============================================================
   RESPONSIVE X PADDING
============================================================ */

.responsive-x-padding {
  padding-right:
    10px !important;

  padding-left:
    10px !important;
}

@media (min-width: 600px) {
  .responsive-x-padding {
    padding-right:
      10px !important;

    padding-left:
      10px !important;
  }
}

@media (min-width: 960px) {
  .responsive-x-padding {
    padding-right:
      64px !important;

    padding-left:
      64px !important;
  }
}

@media (min-width: 1280px) {
  .responsive-x-padding {
    padding-right:
      80px !important;

    padding-left:
      80px !important;
  }
}

@media (min-width: 1920px) {
  .responsive-x-padding {
    padding-right:
      200px !important;

    padding-left:
      200px !important;
  }
}


/* ============================================================
   UTILITY LEFT / RIGHT
============================================================ */

.utility-left,
.utility-right {
  display: flex;

  min-width: 0;

  align-items: center;
}

.utility-right {
  flex: 0 0 auto;

  margin-left: auto;

  gap: 2px;
}


/* ============================================================
   UTILITY CONTROLS
============================================================ */

.utility-contact,
.currency-button,
.account-button {
  border: 0;

  color: inherit;

  cursor: pointer;

  font-family: inherit;

  font-size: 11px;
}

.utility-contact {
  padding:
    0
    6px;
}


/* ============================================================
   ACCOUNT
============================================================ */

.account-button {
  display: flex;

  min-height: 22px;

  margin-left: 10px;

  padding:
    0
    7px;

  align-items: center;

  gap: 4px;

  border-radius: 3px;

  background:
    rgba(
      0,
      0,
      0,
      0.06
    );
}

.account-name {
  max-width: 150px;

  overflow: hidden;

  white-space: nowrap;

  text-overflow: ellipsis;
}


/* ============================================================
   CART
============================================================ */

.cart-total {
  margin:
    0
    4px;

  font-size: 10px;

  white-space: nowrap;
}

.utility-icon-button {
  width:
    26px !important;

  height:
    26px !important;

  min-width:
    26px !important;

  color:
    inherit !important;
}


/* ============================================================
   CURRENCY
============================================================ */

.currency-button {
  display: inline-flex;

  align-items: center;

  gap: 2px;

  padding:
    0
    4px;

  white-space: nowrap;
}


/* ============================================================
   RESPONSIVE NAVIGATION
============================================================ */

/*
 * IMPORTANT:
 *
 * Desktop navigation is intentionally shown only from 1200px.
 *
 * This prevents iPads, tablets and smaller-width devices from
 * attempting to render the complete menu system in insufficient
 * horizontal space.
 *
 * >= 1200px = desktop menu
 * < 1200px  = hamburger / existing mobile drawer
 */

.main-app-bar__nav-icon {
  flex: 0 0 auto;

  min-width: 0;

  color:
    inherit !important;
}


/* ============================================================
   DESKTOP MENU
============================================================ */

.desktop-nav {
  display: flex !important;
}


/* ============================================================
   MOBILE / TABLET MENU BUTTON
============================================================ */

.mobile-nav-toggle {
  display: none !important;
}


/* ============================================================
   LOGO
============================================================ */

.header-logo-link {
  position: relative;

  z-index: 3;

  display: flex;

  flex:
    0
    0
    205px;

  width: 205px;
  min-width: 205px;

  height: 56px;

  align-items: center;
  justify-content: flex-start;

  overflow: hidden;

  text-decoration: none;
}

.header-logo-image {
  width: 180px;

  max-width: 100%;

  height: 42px;

  margin: 0;
}

.header-logo-image
:deep(.v-img__img) {
  object-fit:
    contain !important;

  object-position:
    left center !important;
}


/* ============================================================
   DESKTOP MENUS
============================================================ */

.main-app-bar__menus {
  display: flex;

  flex:
    1
    1
    auto;

  min-width: 0;

  height: 100%;

  align-items: center;
  justify-content: center;
}

.main-app-bar__menus
:deep(.v-btn) {
  margin-top:
    0 !important;
}


/* ============================================================
   RIGHT ACTIONS
============================================================ */

.main-app-bar__right {
  display: flex;

  flex:
    0
    0
    auto;

  min-width: 0;

  margin-left: auto;

  align-items: center;

  gap: 3px;
}

/* =========================================================
   SYSTEM BAR LAYOUT
   Social icons LEFT
   Telephone + Login + Theme RIGHT
   ========================================================= */

.header-bar-shell {
  width: 100%;
}

.system-bar {
  width: 100%;
}

.header-fluid-container {
  width: 100%;
  max-width: 100% !important;
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.system-bar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

/* ---------------------------------------------------------
   LEFT: SOCIAL ICONS
   --------------------------------------------------------- */

.system-bar-left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-shrink: 0;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

/* ---------------------------------------------------------
   RIGHT: TEL + LOGIN + THEME
   --------------------------------------------------------- */

.system-bar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  /* This is what forces the group to the far right */
  margin-left: auto;

  gap: 8px;
  flex-shrink: 0;
}

.main-app-bar__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.system-login-button {
  display: inline-flex;
  align-items: center;
}

.system-theme-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}


/* ============================================================
   ACTION BUTTONS
============================================================ */

.system-action-button {
  min-width:
    58px !important;

  height:
    54px !important;

  padding:
    2px
    5px !important;

  border-radius:
    6px;

  color:
    inherit !important;

  text-transform:
    none;
}

.system-action-button
:deep(.v-btn__content) {
  display: flex;

  width: 100%;
  height: 100%;

  flex-direction: column;

  align-items: center;
  justify-content: center;
}

.system-action-content {
  display: flex;

  width: 100%;
  height: 100%;

  flex-direction: column;

  align-items: center;
  justify-content: center;

  gap: 1px;
}

.system-action-label {
  display: block;

  max-width: 70px;

  overflow: hidden;

  font-size: 8px;
  font-weight: 400;

  line-height: 1;

  text-align: center;

  text-overflow: ellipsis;

  white-space: nowrap;
}


/* ============================================================
   TABLET / MOBILE MENU BREAKPOINT
============================================================ */

@media (max-width: 1199px) {
  /*
   * Hide all full desktop menu components.
   */
  .desktop-nav {
    display: none !important;
  }

  /*
   * Show the existing hamburger button.
   */
  .mobile-nav-toggle {
    display: inline-flex !important;
  }

  /*
   * Allow the logo area to release unused width.
   *
   * The visual logo size itself remains unchanged here.
   */
  .header-logo-link {
    flex:
      1
      1
      auto;

    width: auto;

    min-width: 0;

    max-width: 205px;
  }

  /*
   * Keep the right-side actions pushed to the right.
   */
  .main-app-bar__right {
    margin-left: auto;
  }
}


/* ============================================================
   TABLET / SMALLER SCREEN
============================================================ */

@media (max-width: 959px) {
  .main-app-bar__content {
    gap: 5px;
  }

  .header-logo-link {
    flex:
      1
      1
      auto;

    width: auto;

    min-width: 0;

    max-width: 170px;
  }

   .header-fluid-container {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .system-bar-left {
    gap: 4px;
  }

  .system-bar-right {
    gap: 4px;
  }

  .login-text {
    display: none;
  }


 .header-logo-link {
    flex: 1 1 0;
    width: 0;
    min-width: 0;
    max-width: none;
    height: 60px;
  }

  .header-logo-image {
    width: 100%;
    max-width: 100%;
    height: 58px;
  }

  .main-app-bar__right {
    margin-left: auto;
  }

  .system-action-button {
    min-width:
      46px !important;

    height:
      50px !important;

    padding:
      2px
      3px !important;
  }

  .system-action-label {
    max-width: 48px;

    font-size: 7px;
  }
}


/* ============================================================
   PHONE
============================================================ */

@media (max-width: 599px) {
  .utility-contact {
    display: none;
  }

  .account-button {
    margin-left: 0;
  }

  .account-name {
    max-width: 80px;
  }

  .currency-button {
    display: none;
  }

  .cart-total {
    display: none;
  }

  .header-logo-link {
    max-width: 145px;
  }

  .header-logo-image {
    width: 125px;

    height: 36px;
  }

  .system-action-button {
    width: 40px;

    min-width:
      40px !important;

    padding:
      1px !important;
  }

  .system-action-label {
    max-width: 40px;

    font-size: 6.5px;
  }
}


/* ============================================================
   VERY SMALL PHONE
============================================================ */

@media (max-width: 399px) {
  .main-app-bar__content {
    gap: 2px;
  }

  .header-logo-link {
    max-width: 120px;
  }

  .header-logo-image {
    width: 110px;

    height: 34px;
  }

  .system-action-button {
    width: 36px;

    min-width:
      36px !important;
  }

  .system-action-label {
    max-width: 36px;

    font-size: 6px;
  }
}
</style>